<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>

<div class="mainContainer">
    <app-menu selectedItem="kundenauswahl" class="menu" [class.open]="mobileMenuOpen"></app-menu>
    <div class="content" [class.closed]="mobileMenuOpen">
        <h1>
            Übersicht Ihrer Kautionskunden
        </h1>
        <h2>
            Bitte wählen Sie einen Kunden
        </h2>

        @if (kundenData) {
            <pagination
                [numItems]="kundenData.length"
                [current]="currentOffset"
                (goToPageEvent)="pagerAction($event)"></pagination>
        }
        <elem-table [tableData]="visibleKundenData"
                    [tableMeta]="kundenMetaData"
                    [detailsClass]="'openDetails'"
                    [actionFn]="getActionLinkFunction()"
                    [targetParam]="kundenTargetParam"
                    [searchAction]="searchMe"
                    [currentOffset]="currentOffset"
                    [lineHasChild]="false"
                    (goToPageEvent)="pagerAction($event)"></elem-table>
        @if (kundenData) {
            <pagination
                [numItems]="kundenData.length"
                [current]="currentOffset"
                (goToPageEvent)="pagerAction($event)"></pagination>
        }

    </div>
</div>
